import { useState } from "react";
import { NavLink, Link } from "react-router-dom";


const Sidebar = () => {

  const [openDatos, setOpenDatos] = useState(false);
  const [openFact, setOpenFact] = useState(false);
  const [openList, setOpenList] = useState(false);

  return (

    <div className="sidebar">



      <img
        src="/logo.png"
        alt="Pulso"

      />





      <div className="sidebar-menu">

        {/* DATOS */}

        <button
          className="sidebar-button"
          onClick={() => setOpenDatos(!openDatos)}
        >
          Datos
        </button>

        {
          openDatos && (

            <div className="submenu">

              <NavLink to="/alumnos" className="submenu-item">
                Alumnos
              </NavLink>

              <NavLink to="/favoritos" className="submenu-item">
                Favoritos
              </NavLink>

              <NavLink to="/secciones" className="submenu-item">
                Secciones
              </NavLink>

            </div>
          )
        }


        {/* FACTURACION */}

        <button
          className="sidebar-button"
          onClick={() => setOpenFact(!openFact)}
        >
          Facturación
        </button>

        {
          openFact && (

            <div className="submenu">

              <NavLink to="/liquidar" className="submenu-item">
                Liquidar
              </NavLink>

              <NavLink to="/varalumnos" className="submenu-item">
                Var Alumnos
              </NavLink>

              <NavLink to="/varsecciones" className="submenu-item">
                Var Secciones
              </NavLink>

              <NavLink to="/verliquidaciones" className="submenu-item">
                Ver Liquidaciones
              </NavLink>

              <NavLink to="/conceptos" className="submenu-item">
                Conceptos
              </NavLink>


            </div>
          )
        }


        {/* LISTADOS */}

        <button
          className="sidebar-button"
          onClick={() => setOpenList(!openList)}
        >
          Listados
        </button>

        {
          openList && (

            <div className="submenu">

              <NavLink to="/repoAlumnos" className="submenu-item">
                Alumnos
              </NavLink>

            </div>
          )
        }

      </div>

    </div>

  );
};

export default Sidebar;